import React, { useState } from 'react';
import { Tab, Nav, Container, Row, Col, Card, Badge, Modal, Button } from "react-bootstrap";
import { ArrowRightCircle, CheckCircleFill, ExclamationCircleFill } from "react-bootstrap-icons";


  const bigFixData = [
    {
      id: 1,
      caption: "Discover and Inspect Devices Dynamically ",
      summary: "Large scale construction environment was not able to discover unmanaged assets.",
      briefSummary:`Large scale construction environment was not able to discover unmanaged assets.`,
      resolution: `We deployed a task from the BigFix Console which ran Nmap and Npcap to targeted 
        machines and designate them as "Scan Points". After this Task completes, we were able to initiate
         network scans to search for unmanaged computers and network devices from each selected "Scan Point".
          The results of each scan were uploaded to the BES Server and the Import Service made the data 
          available to the BES Console.`,
      tags: 'Asset Discovery, Construction Company',
    },
    {
        id: 2,
        caption: "Streamlining Security  ",
        summary: "The decentralized patch management approach resulted in compliance gaps and increased vulnerability to cyber threats.",
        briefSummary:`A leading financial services firm with a vast network of endpoints struggled to maintain compliance and security standards across multiple offices. The decentralized patch management approach resulted in compliance gaps and increased vulnerability to cyber threats.
     `,
        resolution: `The firm implemented BigFix Patch Management to centralize and automate its patching processes. The platform's scalability ensured coverage across various endpoints including servers. They achieved regulatory compliance through consistent and timely patching and reduced the risk of cyber threats and potential financial losses.`,
        tags: 'Patch Management,  Endpoints, Reporting, Financial Institution',
      },
      {
        id: 3,
        caption: "Deploying Custom Softwares on Pan India location systems",
        summary: "The manual deployment process was time-consuming and resulted in inconsistent software versions.",
        briefSummary:`A large financial institution faced challenges in deploying and updating financial software applications on both employee workstations and customer-facing systems. The manual deployment process was time-consuming and resulted in inconsistent software versions.`,
        resolution: `The financial institution leveraged BigFix Software Distribution to automate the 
        deployment of financial software applications. The platform's reporting capabilities provided 
        visibility into the status of software installations across the organization. They ensured consistency
         in software versions, reducing compatibility issues and accelerated the deployment of critical
          financial software updates. We have improved customer experience with more reliable and up-to-date 
          banking applications.`,
        tags: 'Software Distribution, Financial Institution',
      },
      {
        id: 4,
        caption: "Control Desktops Remotely ",
        summary: "The existing remote-control tools were fragmented, lacking centralized management and reporting capabilities.",
        briefSummary:`A multinational IT services provider with clients across the globe needed an efficient remote support solution to address technical issues promptly. The existing remote-control tools were fragmented, lacking centralized management and reporting capabilities.`, 
        resolution: `The IT services provider implemented BigFix Remote Control to streamline remote support 
        operations. The platform's centralized management allowed IT teams to initiate remote sessions,
         troubleshoot issues, and deploy updates across client systems. The robust reporting capabilities 
         provided insights into support activities.
        Remote Control Targets are installed on all the endpoints and Remote-Control controllers are
         deployed onto only those users’ systems who are allow to take the remote of other systems like 
         administrators. Customer replaced traditional remote-control tool with the BigFix Remote Control
          service.
        `,
        tags: 'Remote control,  ITeS',
      },
      {
        id: 6,
        caption: "Advanced Analytics and Insights",
        summary: "issue with collecting the data from different security solutions and ITSM solutions.",
        briefSummary:`BFSI customers faced a major issue with collecting the data from different security solutions and ITSM solutions sources for the analytics.`, 
        resolution: `We set up the BigFix insights data-lake to which helped them gather the data from BigFix 
        multiple instances data source and ITSM tool and perform the analytics on top of it and BigFix inventory
         data ingestion into the ITSM. Also, that helped them to generate interactive
         Dashboards Power-BI/Tableau or any Other BI tools for making data driven decisions with confidence..`,
        tags: 'Analytics, IVR, Remediation, Inventory',
      },
      {
        id: 7,
        caption: "Vulnerability Remediation ",
        summary: "Issue to analyze the sheer volume of vulnerabilities and it’s remediations",
        briefSummary:`The customer IT Security & operation team faced issue to analyze the sheer volume of vulnerabilities and it’s remediations.`,
        resolution: `We set up the BigFix Insights for vulnerability remediation integrations which collected the vulnerabilities
         detected by Vulnerability management solutions (Tenable/Qualys/Rapid7 or any Vulnerabilities CSV file import) as well as the 
         applicable patches data from BigFix. then it does the automated vulnerabilities vs patching mapping. which helped them to find 
         out which vulnerabilities will get fixed which latest patches, that eliminated the manual efforts of operation teams to find the
          CVE VS patches data, and that helped them to fix the vulnerabilities faster than ever and decreases the threat landscape and 
          improved security posture.`,
        tags: 'Patching, Compliance, IVR, Stock Exchange',
      },
      {
          id: 8,
          caption: "Maintain Asset Inventory",
          summary: "Manual tracking processes were time-consuming and prone to errors.",
          briefSummary:`A multinational manufacturing company with an extensive IT infrastructure faced challenges in managing its software assets efficiently. The company had diverse software applications across different departments, making it difficult to track licenses, ensure compliance, and optimize software usage. Manual tracking processes were time-consuming and prone to errors.
       `,
          resolution: `The manufacturing company adopted BigFix Inventory to enhance its software asset management practices. The platform's key features were utilized to address specific challenges:

          1.	Automated Discovery and Inventory: BigFix Inventory was deployed to automatically discover and catalog all software assets across the organization's network. This included applications installed on servers, workstations, and other endpoints.
          
          2.	License Management: The platform facilitated the creation of a centralized repository for software licenses. It provided real-time insights into license usage, helping the company ensure compliance with license agreements and avoid over-licensing or under-licensing.
          `,
          tags: 'Discovry, Inventory, Manufacturing Company',
        },
        {
          id: 9,
          caption: "Software Metering",
          summary: "The lack of visibility into software utilization ",
          briefSummary:`A multinational financial institution faced Audit challenges in managing its extensive software portfolio efficiently. The organization wanted to gain insights into software usage patterns to optimize licensing costs, ensure compliance, and enhance overall IT governance. The lack of visibility into software utilization posed challenges in making informed decisions about software procurement and renewal.`,
          resolution: `We offered software metering capabilities to track usage patterns. This data allowed the organization to optimize software licenses based on actual usage, potentially leading to cost savings.`,
          tags: 'Inventory, Financial Institution',
        },
        {
          id: 10,
          caption: "Security Configuration assessment and  Security configuration management ",
          summary: "Faced issue to collect/assess the security configuration ",
          briefSummary:`Customer faced issue to collect/assess the security configuration hardening compliance status every servers/endpoints for various external checklist like CIS, DISA-Stig and custom in-house security configuration controls.`, 
          resolution: `
          We implemented BigFix Compliance solutions which helped customer to assess & remediate the security configurations for their servers and Endpoints for the Operating systems, Browsers, and databases and 3rd party applications like IIS, Apache http & Tomcat for Standards like CIS, DISA-STIG, USGSCB and custom controls checklists. Additionally, BigFix also helped them to track the historical configurations compliance reporting to prove the continuous compliance.
          
          `,
          tags: 'Compliance, Security Configuration assessment and remediation,  Banking',
        },
        {
          id: 11,
          caption: "Database and Middleware patching ",
          summary: "The patching & compliance reporting for extensive databases & Middleware platforms.",
          briefSummary:`The BFSI faced challenges to achieve the patching & compliance reporting for extensive databases & Middleware platforms.`, 
          resolution: `We helped them to identify the unpatched databases & middleware. Which was tough and purely manual task for them to do on each server for each database and middleware.
          post the identification of applicable patches for we also helped them to achieve the timely patching for databases & middleware’s and reporting from single console. 
          `,
          tags: 'Database Patching,  Middleware Patching, Compliance, Financial Institution',
        },
        {
          id: 12,
          caption: "Vulnerability analysis",
          summary: "Quickly find the bulk CVE’s and affected endpoints/servers ",
          briefSummary:`Customer faced the issues to quickly find the bulk CVE’s and affected endpoints/servers and it’s remediations.`, 
          resolution: `We helped the customer to perform the bulk CVE search engine which performs the bulk CVE’s and its applicable patches, also we given them threat intelligence (vulnerability already been exploited somewhere in the world) MITRE APT (Advance Persistent Groups) groups and CISA Know exploitable vulnerabilities to give the contextual prevalent in customer environments to prioritize the vulnerability remediations.We helped the customer to perform the bulk CVE search engine which performs the bulk CVE’s and its applicable patches, also we given them threat intelligence (vulnerability already been exploited somewhere in the world) MITRE APT (Advance Persistent Groups) groups and CISA Know exploitable vulnerabilities to give the contextual prevalent in customer environments to prioritize the vulnerability remediations.`,
          tags: 'IVR, Analysis',
        },
  ];

  const solarWindsData = [
    {
      id: 1,
      caption:
        "Mass firmware upgrade activity for a bank customer for RBI compliance",
      summary: "Firmware upgrade activities for their branch devices ",
      briefSummary: `During the beginning of the lockdown, the customer reported that they had to perform mass level firmware upgrade activities for their branch devices (7000+ Cisco Devices). This activity was to be completed within a set timeframe and due to lockdown, physical visit to branches was impossible. `,
      resolution: `Solarwinds NCM has a feature called firmware upgrades. Using that, and without any physical presence of any engineer on site, the bank customer successfully upgraded 7000+ devices in a stagsgered manner within 1 month.`,
      tags: "NCM, Bank",
    },
    {
      id: 2,
      caption: "Identifying expensive queries on the database",
      summary: `Poor performance on the MSSQL database server and during each CPU peak`,
      briefSummary: `The customer reported poor performance on the MSSQL database server and during each CPU peak, wanted to know the details of queries hogging the resources.
         `,
      resolution: `Using Server & Application Monitoring (SAM) module’s AppInsight for SQL template, which polls for most expensive queries by CPU time. In a customized alert, we put the condition to send the details of the most expensive queries in mail whenever there was a peak in CPU utilization.`,
      tags: "SAM, SQL,ITeS, Oracle ",
    },
    {
      id: 3,
      caption: "Identifying poorly created queries in an in-house application",
      summary: "Performance issues of an in-house application",
      briefSummary: `The users in a large IT company used to regularly complain for performance issues of an in-house application.`,
      resolution: `Using Solarwinds DPA, we worked with the developers of the in-house application, to identify long running queries, most expensive queries, queries that caused deadlocks, blocks, queries with highest wait times, table tuning advisories, index recommendations, etc. All these inputs highly helped the developers to fine tune and highly improve the application performance. `,
      tags: "DPA, SQL",
    },
    {
      id: 4,
      caption:
        "Requirements for highly customized dashboards for CXOs, L1/L2/L3 Engineers, Application Teams and Engineers, etc.",
      summary: "Highly customizable dashboards for various teams and levels.",
      briefSummary: `At all our customer environments, we have met with requirements for highly customizable dashboards for various teams and levels.`,
      resolution: `We have created L1/L2/L3 dashboards catering individually to Network/Server/DB/Storage teams which contain more granular data pertaining to their devices and CXO dashboards with a high-level overview of their environment to provide overall performance status, health & infrastructure visibility.
            `,
      tags: "NPM, SRM, SAM, DB",
    },
    {
      id: 5,
      caption: "Identifying reasons behind poor application performance",
      summary: "unable to troubleshoot the issues faced in application stack",
      briefSummary: `Customer brought a case where they were unable to troubleshoot the issues faced in application stack for which their customers complained of poor performance.`,
      resolution: `The first step was to create NPM’s NetPath and WPM from remote locations for checking service availability and website performance. It was observed that the website often gave out connection reset error,  after which the whole ongoing transaction was lost.
    Next, we put the database under DPA monitoring, but even the database performance did not give out any issues and database reported back relatively normal.
    For the next step in troubleshooting, we monitored all the services and processes related to the complete application stack and the database servers as well. Here, using the SAM application dependency feature, it was observed that there was a very high amount of packet loss between the application and the database layer servers. 
    To confirm this, we created customized templates, which constantly checked for a few parameters between the application and DB servers, such as ping, traceroute, and port connectivity. It was identified that the connectivity between the servers broke a lot during the whole day, and using the Perfstack feature, it was identified that those times coincide with the times when the website gave out connection reset error. 
    Alongside, in the Perfstack, we also observed that there was very high resource utilization on the host server as well, and coincidentally, there were spikes in the host utilization which occurred around the same time as website reset errors.
    The customer took the decision to move the complete setup to physical hardware. The platform was still under the same rigorous monitoring after movement to the physical setup, and no issues were reported after that. The errors from the customer side stopped, and the connection reset error vanished.
    .`,
      tags: "NPM, SAM, WPA, DB, Server",
    },
    {
      id: 6,
      caption: "Identifying website slowness causes using WPM",
      summary: "The website took a lot of time to load. ",
      briefSummary: `The customers accessing the main website of a global call center always complained that the website took a lot of time to load. The team underwent a rigorous check on the database side, on the application server, and still wasn't able to determine the cause behind the same.`,
      resolution: `The customer brought this concern to us during implementation phase. We created a website transaction and put it under monitoring from various locations. Upon checking the TCP waterfall chart, it was found that the image used on the website was very large in size, hence always took time to load. 
    On changing the image to a smaller size, the website loading time reduced and the performance improved greatly. The customer website slowness issue was resolved.
    `,
      tags: "WPM, NPM, Call-center",
    },
    {
      id: 7,
      caption: "Understanding gaps in the wireless setup deployment",
      summary: "Complaints of poor wireless connectivity ",
      briefSummary: `The customer often faced complaints of poor wireless connectivity from their users.`,
      resolution: `After putting the whole wireless infra under monitoring, it was observed that there were some clusters with a very high number of users connected to a single access point. Through custom properties, the team had exact idea of the region, office, location, floor of the device and through the wireless data, the users connected on the access point and their signal strength values as well. Accordingly, customer understood the need to expanding the wireless infrastructure. In a course of few months, the customer resolved the issues at all their sites, and they saw a drastic decrease in the number of cases reported for network issues.`,
      tags: "NPM, Manufacturing Customer",
    },
    // {
    //   id: 8,
    //   caption: "Identifying causes of slowness",
    //   summary: "Slowness in the network.",
    //   briefSummary: `We asked the network team to configure NetFlow on their routers. Using NTA, it was found that their patching activity was being carried out unthrottled, which was causing the bandwidth to be completely utilized. Also, there were some machines which were not getting patched through their relay architecture, and were directly reporting to the main server, hence hogging bandwidth on both sides.
    //                  After reporting this, the customer improved their relay architecture, changed the scheduled timings for patching activity and throttled the maximum bandwidth that could be taken by their patching solution. After a few weeks, customer saw drastic improvement in their network performance.
    //           `,

    //   tags: "NPM, Bank",
    // },
    {
      id: 9,
      caption:
        "Integration with Slack/Microsoft Teams and Existing SMS Gateways",
      summary: "Request for smart alerting in the tools ",
      briefSummary: `Customers have requested for smart alerting in the tools they already have in their environment – Teams, Slack, etc. and the critical alerts to be received in the form of messages.`,
      resolution: `Using the API integrations provided by SMS Gateways and Teams/Slack, we created requests to trigger to the server every time the alert was triggered. Using API integrations, critical SMS alerts were sent on the engineer’s phone.`,
      tags: "NPM, API Integration, Alert",
    },
    {
      id: 10,
      caption: "Identifying ISP Slowness",
      summary: "Observed latency from their ISP end",
      briefSummary: `Customer reported that they have observed latency from their ISP end, but were not able to completely confirm it.`,
      resolution: ` Using the SolarWinds NetPath feature, we created multiple NetPath from their various locations. NetPath showed slowness whenever it occurred and also demonstrated which hop was the culprit. Through NetPath, the customer was able to identify slowness in the ISP environment, and get it rectified.
              `,
      tags: "NPM, NetPath, Stock Exchange",
    },
    {
      id: 11,
      caption: "Identifying the reason for BGP neighbor down ",
      summary:
        "Customer having large number of branches and each branch connected with more than one ISP link",
      briefSummary: `The customer having large number of branches and each branch connected with more than one ISP link. Often the engineers would shut one of the links if they experienced some packet loss or latency in order to use a more efficient link during the day. But often the engineers would forget to up the links and hence the traffic flowing through the secondary link instead of primary.`,
      resolution: `We Created a BGP neighbor down alert. On detecting a BGP neighbor down event, SolarWinds NCM would take a backup of the router’s configuration. Which would then be used by NCM compliance to search for the neighbor shutdown command. If the command was present, then this would show up in the report.
              `,
      tags: "NCM",
    },
    {
      id: 12,
      caption: "Router last reload reason",
      summary: "The last reload reason for Branch routers after an outage.",
      briefSummary: `One of our banking customer wanted to know the last reload reason for Branch routers after an outage.`,
      resolution: `We first identified the specific OID value, then used the UnDP to create a custom poller to poll the OID specific value and once we received this value, the value was passed on to the incident ticket information.`,
      tags: "NPM, Bank",
    },
  ];

// --- COMPONENT: Individual Card ---
const CaseStudyCard = ({ item }) => {
  const [show, setShow] = useState(false);
  
  // Split tags string into an array
  const tagsArray = item.tags ? item.tags.split(',').map(tag => tag.trim()) : [];

  return (
    <>
      <Card className="case-card h-100 shadow-sm border-0" onClick={() => setShow(true)}>
        <Card.Body className="d-flex flex-column">
          <div className="mb-3">
             {/* Render first tag as a category label */}
            {tagsArray.length > 0 && (
                <Badge bg="light" text="dark" className="mb-2 border">{tagsArray[0]}</Badge>
            )}
            <Card.Title className="fw-bold text-primary">{item.caption}</Card.Title>
          </div>
          
          <Card.Text className="text-muted flex-grow-1">
            {item.summary}
          </Card.Text>

          <div className="mt-4 pt-3 border-top d-flex justify-content-between align-items-center">
            <span className="fw-semibold text-primary" style={{fontSize: '0.9rem'}}>Read Case Study</span>
            <ArrowRightCircle size={20} className="text-primary" />
          </div>
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal style={{zIndex:"99999999999"}} show={show} onHide={() => setShow(false)} size="lg" centered className="case-modal">
        <Modal.Header closeButton className="border-0 pb-0">
            {/* Empty header for layout, title is in body */}
        </Modal.Header>
        <Modal.Body className="px-4 pb-4">
          <h3 className="fw-bold mb-4 text-primary">{item.caption}</h3>
          
          <div className="modal-section mb-4 p-3 bg-light rounded-3">
            <h5 className="d-flex align-items-center fw-bold text-danger">
                <ExclamationCircleFill className="me-2"/> The Challenge
            </h5>
            <p className="mb-0 text-secondary">{item.briefSummary}</p>
          </div>

          <div className="modal-section mb-4 p-3 border border-success border-opacity-25 rounded-3 bg-success bg-opacity-10">
            <h5 className="d-flex align-items-center fw-bold text-success">
                <CheckCircleFill className="me-2"/> The Solution
            </h5>
            <p className="mb-0 text-dark">{item.resolution}</p>
          </div>

          <div className="d-flex flex-wrap gap-2 mt-4">
            {tagsArray.map((tag, idx) => (
              <Badge key={idx} bg="secondary" className="fw-normal px-3 py-2">
                {tag}
              </Badge>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer className="border-0 pt-0">
          <Button variant="outline-secondary" className='custom-button2' onClick={() => setShow(false)}>
            <span>Close</span></Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

// --- COMPONENT: Grid Wrapper ---
const CaseStudyGrid = ({ data }) => {
  return (
    <Row className="g-4">
      {data.map((item) => (
        <Col key={item.id} xs={12} md={6} lg={4}>
          <CaseStudyCard item={item} />
        </Col>
      ))}
    </Row>
  );
};

// --- MAIN COMPONENT ---
export const Resource = () => {
  return (
    <section className="py-5 ">
      <Container>
        <div className="text-center mb-5">
          <h1 className="fw-bold display-5">Case Study</h1>
        </div>

        <Tab.Container id="projects-tabs" defaultActiveKey="bigfix">
          <Nav variant="pills" className="justify-content-center mb-5 custom-pills">
            <Nav.Item>
              <Nav.Link eventKey="bigfix" className="px-4 py-2 fw-semibold">BigFix</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="solarwinds" className="px-4 py-2 fw-semibold">SolarWinds</Nav.Link>
            </Nav.Item>
          </Nav>

          <Tab.Content>
            <Tab.Pane eventKey="bigfix">
              <CaseStudyGrid data={bigFixData} />
            </Tab.Pane>
            <Tab.Pane eventKey="solarwinds">
              <CaseStudyGrid data={solarWindsData} />
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Container>
    </section>
  );
};